import { useEffect, useRef } from 'react'
import JsBarcode from 'jsbarcode'

type Props = { value: string }

function Barcode({ value }: Props) {
  const renderElementRef = useRef<HTMLCanvasElement | null>(null)

  useEffect(() => {
    if (!value) return

    const renderBarcode = JsBarcode
    renderBarcode(renderElementRef.current, value, { height: 75 })
  }, [value])

  return value ? <canvas ref={renderElementRef} /> : null
}

export { Barcode }
